<template>
  <div v-if="settings" class="ebms-shell">
    <EbmSettingsItem title="Business Info" icon="briefcase" :items="mainInfo" />
    <EbmSettingsItem title="Last Request Dates" icon="calendar" :items="lastRequestDates" />
    <EbmSettingsItem title="Tax Rates" icon="percent" :items="taxRates" />

    <div class="ebms-meta">
      <div class="ebms-meta__item">
        <vue-feather type="user" size="13" class="ebms-meta__icon" />
        <span class="ebms-meta__label">Last updated by</span>
        <span class="ebms-meta__value">{{ recordedBy?.names || "N/A" }}</span>
      </div>
      <div class="ebms-meta__item">
        <vue-feather type="clock" size="13" class="ebms-meta__icon" />
        <span class="ebms-meta__label">Last updated at</span>
        <span class="ebms-meta__value">{{ recordedBy?.updated_at || "N/A" }}</span>
      </div>
    </div>
  </div>

  <div v-else class="ebms-empty">
    <div class="ebms-empty__title">Set up RRA EBM for this store</div>
    <div class="ebms-empty__sub">Follow the steps below to request your EBM settings</div>
    <EbmSettingsSteps />
  </div>
</template>

<script>
import EbmSettingsItem from "./EbmSettingsItem.vue";
import EbmSettingsSteps from "./EbmSettingsSteps.vue";

export default {
  name: "EbmSettings",
  components: { EbmSettingsItem, EbmSettingsSteps },
  props: {
    settings: { type: Object, required: true },
  },
  data() {
    return {
      mainInfo: {},
      lastRequestDates: {},
      taxRates: {},
      recordedBy: null,
    };
  },
  mounted() {
    if (this.settings) {
      this.mainInfo = {
        tin: this.settings.tin,
        bhfId: this.settings.bhfId,
        dvcSrlNo: this.settings.dvcSrlNo,
        ebm_activated: this.settings.ebm_activated,
        mrc: this.settings.mrc,
        vat_activated: this.settings.vat_activated,
        topMsg: this.settings.topMsg,
        btmMsg: this.settings.btmMsg,
      };
      this.lastRequestDates = {
        import_last_request_date: this.settings.import_last_request_date,
        purchase_last_request_date: this.settings.purchase_last_request_date,
      };
      this.taxRates = {
        default_tax_A_rate: this.settings.default_tax_A_rate,
        default_tax_B_rate: this.settings.default_tax_B_rate,
        default_tax_C_rate: this.settings.default_tax_C_rate,
        default_tax_D_rate: this.settings.default_tax_D_rate,
      };
      this.recordedBy = {
        names: this.settings.recorded_by?.names,
        phone_number: this.settings.recorded_by?.phone_number,
        updated_at: this.settings.updated_at,
      };
    }
  },
};
</script>

<style scoped>
.ebms-shell {
  display: grid;
  gap: 1rem;
}

.ebms-meta {
  align-items: center;
  background: color-mix(in srgb, var(--hs-bg-soft) 64%, transparent);
  border: 1px solid var(--hs-border);
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  padding: 0.85rem 1.1rem;
}

.ebms-meta__item {
  align-items: center;
  display: flex;
  gap: 0.4rem;
}

.ebms-meta__icon {
  color: var(--hs-muted);
  flex-shrink: 0;
}

.ebms-meta__label {
  color: var(--hs-muted);
  font-size: 0.78rem;
}

.ebms-meta__value {
  color: var(--hs-text);
  font-size: 0.82rem;
  font-weight: 650;
}

.ebms-empty {
  display: grid;
  gap: 0.5rem;
}

.ebms-empty__title {
  color: var(--hs-text);
  font-size: 1.05rem;
  font-weight: 750;
  text-align: center;
}

.ebms-empty__sub {
  color: var(--hs-muted);
  font-size: 0.83rem;
  margin-bottom: 0.5rem;
  text-align: center;
}
</style>
